import { Component } from '@angular/core';
import { NavigateRoutes, RequestType, StorageConstants } from 'common/constants/app.constant';
import { RouteMessage } from 'common/models/utilitymodels/base.model';
import { SystemService } from 'common/services/core_services/system.service';

@Component({
    selector: 'bh-desktop-footer',
    templateUrl: './desktop-footer.component.html',
    styleUrls: ['./desktop-footer.component.scss'],
})
export class DesktopFooterComponent {
    constructor(public systemService: SystemService) {}

    navigateWriteToUs() {
        const routeMsg = new RouteMessage();
        const userData = JSON.parse(this.systemService.getLocalStorage(StorageConstants.userProfile));
        let url;
        if (userData) {
            url = NavigateRoutes.feedBackAndQuery;
            routeMsg.type = RequestType.GET;
        } else {
            url = NavigateRoutes.loginarn;
            routeMsg.type = RequestType.BLANK;
            routeMsg.transferData = {
                postLoginRedirection: NavigateRoutes.feedBackAndQuery,
            };
        }
        this.systemService.routeByUrl(url, routeMsg);
    }
}
